/**
 * @file AppShell.jsx
 * Layout principale dell'applicazione.
 * Compone Sidebar (sinistra), TopBar (in alto) e area contenuto (children).
 * Il Toaster globale è montato qui per essere disponibile ovunque nel DOM.
 */

import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Toaster from '../shared/Toaster';

export default function AppShell({ children }) {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-shell">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar />
        <main className="flex-1 flex flex-col min-w-0 overflow-y-auto bg-shell">
          {children}
        </main>
      </div>
      <Toaster />
    </div>
  );
}
